import RoutesMap from "../../route_control/RouteControl"
import {
    HierarchyList,
    ScheduledList,
    CreateMaintenance
} from "../../pages/maintenance"

export const MaintenanceImport = {
    RoutesMap,
    HierarchyList,
    ScheduledList,
    CreateMaintenance
}